/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateProjectPenaltyDetailsTemplateCommand } from '../../models/update-project-penalty-details-template-command';
import { UpdateProjectPenaltyDetailsTemplateCommandResult } from '../../models/update-project-penalty-details-template-command-result';

export interface ApiProjectPenaltiesDetailsTemplateUpdateProjectPenaltyDetailsTemplatePost$Plain$Params {
      body?: UpdateProjectPenaltyDetailsTemplateCommand
}

export function apiProjectPenaltiesDetailsTemplateUpdateProjectPenaltyDetailsTemplatePost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectPenaltiesDetailsTemplateUpdateProjectPenaltyDetailsTemplatePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectPenaltyDetailsTemplateCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectPenaltiesDetailsTemplateUpdateProjectPenaltyDetailsTemplatePost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateProjectPenaltyDetailsTemplateCommandResult>;
    })
  );
}

apiProjectPenaltiesDetailsTemplateUpdateProjectPenaltyDetailsTemplatePost$Plain.PATH = '/api/ProjectPenaltiesDetailsTemplate/UpdateProjectPenaltyDetailsTemplate';
